import { render, staticRenderFns } from "./UserOrderArrival.vue?vue&type=template&id=51cbec46&scoped=true&"
import script from "./UserOrderArrival.vue?vue&type=script&lang=js&"
export * from "./UserOrderArrival.vue?vue&type=script&lang=js&"
import style0 from "./UserOrderArrival.vue?vue&type=style&index=0&id=51cbec46&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51cbec46",
  null
  
)

export default component.exports